function CartPreview( { items, setItemQuantity, removeItem, addingToCartPreview } ) {
	const { swiftCartTranslations } = window.QalaB2bWholesale.translations;
	return <table className="qala-b2b-wholesale-swift-cart-content">
		<thead>
			<tr>
				<th className="qala-b2b-wholesale-swift-cart-content-table-header-sku">{ swiftCartTranslations.sku }</th>
				<th className="qala-b2b-wholesale-swift-cart-content-table-header-title">{ swiftCartTranslations.title }</th>
				<th className="qala-b2b-wholesale-swift-cart-content-table-header-price">{ swiftCartTranslations.price }</th>
				<th className="qala-b2b-wholesale-swift-cart-content-table-header-quantity">{ swiftCartTranslations.quantity }</th>
				<th className="qala-b2b-wholesale-swift-cart-content-table-header-Stock">{ swiftCartTranslations.stock }</th>
				<th className="qala-b2b-wholesale-swift-cart-content-table-header-actions"></th>
			</tr>
		</thead>
		<tbody>
			{ items.map( item =>
				<tr key={ item.id } className={ item.hasError ? 'qala-b2b-wholesale-swift-cart-content-table-row-error' : 'qala-b2b-wholesale-swift-cart-content-table-row-has' }>
					<td className="qala-b2b-wholesale-swift-cart-content-table-data-sku">
						{ item.isReplaced && <div className="qala-b2b-wholesale-swift-cart-content-table-data-sku-replaced-product">{ swiftCartTranslations.replaced }</div> }
						{ item.sku }
					</td>
					<td className="qala-b2b-wholesale-swift-cart-content-table-data-title">
						<a href={ item.url } target="_blank" rel="noreferrer">{ item.title }</a>
					</td>
					<td className="qala-b2b-wholesale-swift-cart-content-table-data-price">
						<div dangerouslySetInnerHTML={ { __html: item.priceHtml } } />
					</td>
					<td className="qala-b2b-wholesale-swift-cart-content-table-data-quantity">
						<input type="number" value={ item.quantity } onChange={ event => setItemQuantity( item.id, event.target.value ) } min="0" max="99999" />
					</td>
					<td className="qala-b2b-wholesale-swift-cart-content-table-data-stock">
						<div>{ item.stock } </div>
					</td>
					<td className="qala-b2b-wholesale-swift-cart-content-table-data-actions">
						<button className="btn-type-7" onClick={ () => removeItem( item.id ) }>
							<svg xmlns="http://www.w3.org/2000/svg" height="16" width="12" viewBox="0 0 384 512">
								<path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
							</svg>
						</button>
					</td>
				</tr>
			) }
		</tbody>
		{ items.length === 0 && ! addingToCartPreview && <tfoot className="qala-b2b-wholesale-swift-cart-content-footer-no-products">
			<tr>
				<td colSpan="5">
					{ swiftCartTranslations.noProductsAdded }
				</td>
			</tr>
		</tfoot> }
		{ addingToCartPreview && <tfoot className="qala-b2b-wholesale-swift-cart-content-footer-adding">
			<tr>
				<td colSpan="5">
					{ swiftCartTranslations.validatingProduct }
				</td>
			</tr>
		</tfoot> }
	</table>;
}

export default CartPreview;
